var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51657 11.5351C1.51657 6.08622 6.39837 1.80005 12.25 1.80005C18.1016 1.80005 22.9834 6.08622 22.9834 11.5351C22.9834 14.591 21.1377 17.1902 18.9944 19.1406C16.8382 21.1027 14.2622 22.5198 12.5285 23.2132C12.2975 23.3057 12.0356 23.2775 11.8295 23.1379C11.6234 22.9984 11.5 22.7657 11.5 22.5169V20.7435C9.07199 20.5664 6.71404 19.5454 4.90625 18.0389C2.91667 16.381 1.51657 14.0651 1.51657 11.5351ZM12.25 13.0326C13.0771 13.0326 13.7475 12.3622 13.7475 11.5351C13.7475 10.7081 13.0771 10.0376 12.25 10.0376C11.423 10.0376 10.7525 10.7081 10.7525 11.5351C10.7525 12.3622 11.423 13.0326 12.25 13.0326ZM7.75746 13.0326C8.58451 13.0326 9.25497 12.3622 9.25497 11.5351C9.25497 10.7081 8.58451 10.0376 7.75746 10.0376C6.9304 10.0376 6.25994 10.7081 6.25994 11.5351C6.25994 12.3622 6.9304 13.0326 7.75746 13.0326ZM18.2401 11.5351C18.2401 12.3622 17.5696 13.0326 16.7426 13.0326C15.9155 13.0326 15.245 12.3622 15.245 11.5351C15.245 10.7081 15.9155 10.0376 16.7426 10.0376C17.5696 10.0376 18.2401 10.7081 18.2401 11.5351Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.4bf4a2a8a7f8c2ee9aec16a6988475f3.svg";
export { ForwardRef as ReactComponent };